module.exports = __webpack_public_path__ + "img/antes_despues_225.561e3d60.png";